<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'cart-checkout'
}
</script>



// WEBPACK FOOTER //
// src/views/CartCheckout.vue